<template>
    <div class="hero-section">
        <div class="hero-section__breadcrumb">
            <slot name="breadcrumb" />
        </div>
        <div class="hero-section__body">
            <div class="hero-section__title">
                <slot name="title" />
            </div>
            <div class="hero-section__actions">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss">
.hero-section {
  margin-top: var(--spacing-6, 24px);
  margin-bottom: var(--spacing-6, 24px);
}
.hero-section__body {
  display: flex;
  flex-direction: row;
  align-items: end;
  margin-top: var(--spacing-16, 64px);
}
.hero-section__title {
  flex-grow: 1;
}
.hero-section__title h1 {
  color: var(--text--80, #1A2021);
  font-size: var(--spacing-8, 32px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--spacing-9, 36px);
  margin: 0;
}
</style>
